// extracted by mini-css-extract-plugin
export var mediaPage = "MediaPage_mediaPage__apW0H";
export var videoDeck = "MediaPage_videoDeck__FR2gc";
export var heroSlider = "MediaPage_heroSlider__eKqZy";
export var paginator = "MediaPage_paginator__JR2T4";
export var rotate = "MediaPage_rotate__Sw0nK";
export var dotty = "MediaPage_dotty__FLoKz";